import {forEach} from 'ramda';
import bindEvent from '../../scripts/util/bindEvent';
import isElement from '../../scripts/util/isElement';
import qsa from '../../scripts/util/DOM/qsa';
import $ from 'jquery';

const selectors = {
	title: '.js-rates-title',
	switch: '.js-switch-price',
	prices: '.js-prices',
	currency: '.js-currency',
	price: '.js-price-item',
	card: '.js-price-card',
	priceItem: '.js-price',
	wrapp: '.js-switch-wrapp',
	chooseButton: '.js-card-rates-button-choose',
	orderFormErrors: '.signup-form__errors'
};

const classes = {
	active: 'card-rates__switch-price_state_active',
	activeItem: 'card-rates__price-item_state_active',
	activePrice: 'card-rates__price_state_active',
	fade: 'card-rates__card_fade',
	chooseButtonActive: 'card-rates__button-choose-active',
	orderFormError: 'signup-form__errors--show'
};

const defaultPrice = qsa('[data-currency="USD"]');

const onClick = e => {
	const el = e.target;
	const parent = el.closest(selectors.switch);
	parent.classList.add(classes.active);
};

const onClose = e => {
	const el = e.target;
	const parent = el.querySelector(selectors.switch);
	parent.classList.remove(classes.active);
};

const togglePrices = (items, thisPrice) => () => {
	forEach(item => {
		item.classList.remove(classes.activePrice);
	}, items);

	forEach(item => {
		item.classList.add(classes.activePrice);
	}, thisPrice);
};

const unActivate = parent => {
	parent
		.querySelector(`.${classes.activeItem}`)
		.classList.remove(classes.activeItem);
};

const onSwitch = e => {
	const el = e.target;
	const parent = el.closest(selectors.prices);
	const text = el.innerHTML;
	const thisPrice = qsa(`[data-currency="${text}"]`);
	const items = qsa(selectors.priceItem);
	const cards = qsa(selectors.card);

	unActivate(parent);

	el.classList.add(classes.activeItem);


	if (thisPrice.length !== 0) {
		setTimeout(togglePrices(items, thisPrice), 500);
	} else {
		setTimeout(togglePrices(items, defaultPrice), 500);
	}

	forEach(item => {
		item.classList.add(classes.fade);

		setTimeout(() => {
			item.classList.remove(classes.fade);
		}, 1000);
	}, cards);
};

const onChoose = e => {
	e.preventDefault();
	const packageName = $(e.target).data('package');
	$(selectors.chooseButton).removeClass(classes.chooseButtonActive);
	$(e.target).closest(selectors.chooseButton).addClass(classes.chooseButtonActive);
	$('#package').val(packageName);
	$(selectors.orderFormErrors).text('');
	$(selectors.orderFormErrors).removeClass(classes.orderFormError);
};

const render = () => {
	$(selectors.chooseButton).on('click', onChoose);
	if (isElement(selectors.title)) {
		bindEvent(selectors.currency, 'click', onClick);
		bindEvent(selectors.wrapp, 'mouseleave', onClose);
		bindEvent(selectors.price, 'click', onSwitch);
	}
};

export default render;



// WEBPACK FOOTER //
// ./app/blocks/card-rates/card-rates.js